// extracted by mini-css-extract-plugin
export default {"appointmentPage":"appointmentPage_appointmentPage__yQcSX"};